'use strict';
var React = require('react');
var assetsHelper = require('../helper/assetsHelper');
var MultilineText = require('./common/MultilineText');
var PageComments = require('./Review/PageComments');
var runtimeHelper = require('../helper/runtimeHelper');
var i18nHelper = require('../helper/i18n');

var PageRemark = React.createClass({
  propTypes: {
    name: React.PropTypes.string.isRequired,
    page: React.PropTypes.object.isRequired,
    remark: React.PropTypes.string,
    show: React.PropTypes.bool.isRequired,
    onClose: React.PropTypes.func.isRequired,
    isSign: React.PropTypes.bool.isRequired,
    author: React.PropTypes.string.isRequired,
    sign: React.PropTypes.func.isRequired,
    syncID: React.PropTypes.string.isRequired,
    syncVersion: React.PropTypes.string.isRequired,
    pageName: React.PropTypes.string.isRequired,
    comments: React.PropTypes.array,
    onAddComment: React.PropTypes.func.isRequired,
    onLoadComment: React.PropTypes.func.isRequired,
    onError: React.PropTypes.func.isRequired,
    onClearError: React.PropTypes.func.isRequired,
  },
  getInitialState: function () {
    return {
      show: this.props.show,
      author: null,
      current: runtimeHelper.canReview() ? 'comment' : 'remark'
    };
  },
  componentWillReceiveProps: function (nextProps) {
    this.setState({
      show: nextProps.show,
      update: false,
    });
    if (nextProps.page.ID !== this.props.page.ID && runtimeHelper.canReview()) {
      this.props.onLoadComment(this.props.syncID, this.props.syncVersion, nextProps.page.ID);
    }
  },
  componentDidMount: function () {
    runtimeHelper.canReview() && this.props.onLoadComment(this.props.syncID, this.props.syncVersion, this.props.page.ID);
  },
  render: function () {
    var style = {};
    if (this.state.show && this.props.remark) {
      style.right = 0;
    } else {
      style.right = -320;
    }
    var className = 'page-remark';
    if (!runtimeHelper.canReview()) {
      className += ' no-comments';
    }
    return (
      <div className={className} style={style}>
        <img onClick={this.onCloseRemark} className="close" src={assetsHelper.getAsset('close-30.png')}/>
        <div className="tab-bar">
          {runtimeHelper.canReview() &&
          <span className={this.state.current === 'comment' && 'current'} onClick={this.onSwitchToComment}>{i18nHelper.get('COMMENT')}</span> }
          <span className={this.state.current === 'remark' && 'current'} onClick={this.onSwitchToRemark}>{i18nHelper.get('REMARK')}</span>
        </div>
        {this.state.current === 'remark' && <div className="page-remark-content">
          <MultilineText text={this.props.remark}/>
        </div>
        }
        {this.state.current === 'comment' && <PageComments
          comments={this.props.comments}
          onAddComment={this.onAddComment}
          onLoadComment={this.props.onLoadComment}
          onError={this.props.onError}
          onClearError={this.props.onClearError}
          sign={this.props.sign}
        />
        }
      </div>
    )
  },

  onSwitchToComment: function () {
    this.setState({
      current: 'comment'
    });
  },
  onSwitchToRemark: function () {
    this.setState({
      current: 'remark'
    });
  },

  onCloseRemark: function () {
    this.props.onClose();
  },

  removeSign: function () {
    this.props.removeSign();
  },

  onAddComment: function (author, content) {
    this.props.onAddComment(this.props.syncID, this.props.syncVersion, this.props.page.ID, this.props.pageName, author, content);
  }
});

module.exports = PageRemark;


// WEBPACK FOOTER //
// ./src/views/PageRemark.jsx